<template>
    <div class="individual_detial no-trans" v-loading="loading">
        <div class="individual_detial_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> >
                <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/enterprise_list">企业法务</router-link> >
                <span class="span2" aria-current="page">详情</span>
             </div>
             <div class="box_flex">
                <div class="box_left">
                    <div class="box1">
                        <div class="box1_top">
                            <div class="box1_banner">
                                <div class="banner_top" @touchstart.passive="gallery_touch_start" @touchend.passive="gallery_touch_end" @touchcancel="gallery_touch=null">
                                    <img v-if="!mobile_view || banner_list.length" :src="banner_list[banner_ac]" :alt="individual_detial.title || ''">
                                    <i v-else class="el-icon-picture-outline gallery_empty" aria-label="暂无服务图片"></i>
                                    <span v-if="mobile_view && banner_list.length>1" class="gallery_count">{{ banner_ac+1 }} / {{ banner_list.length }}</span>
                                </div>
                                <div class="banner_bom" v-if="!mobile_view || banner_list.length>1">
                                    <div class="banner_btns" role="button" tabindex="0" aria-label="上一张图片" @keydown.enter.prevent="handle_num_clear" @click="handle_num_clear">
                                        <img src="../../../assets/img/index/legal/banner_left.png" alt="">
                                    </div>
                                    <div class="banner_list" ref="banner_list">
                                      <div class="banner_img" v-for="(item,index) in banner_list" :key="index" @click="handle_banner(item,index)" :class="{banner_img_ac:banner_ac==index}">
                                        <img :src="item" alt="">
                                      </div>  
                                    </div>
                                    <div class="banner_btns" role="button" tabindex="0" aria-label="下一张图片" @keydown.enter.prevent="handle_num_add" @click="handle_num_add">
                                        <img src="../../../assets/img/index/legal/banner_right.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="box1_info">
                                <div class="info_title_img">
                                    {{ individual_detial.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="info_consts">
                                    {{ individual_detial.desc }}
                                </div>
                                <div class="info_tage">
                                    <div class="tages" v-if="(individual_detial.cate1||{}).title">{{ (individual_detial.cate1||{}).title }}</div>
                                    <div class="tages" v-if="(individual_detial.cate2||{}).title">{{ (individual_detial.cate2||{}).title }}</div>
                                    <div class="tages" v-if="(individual_detial.cate3||{}).title">{{ (individual_detial.cate3||{}).title }}</div>
                                </div>
                                <div class="info_price">
                                    <div class="price_title">价&nbsp;&nbsp;格</div>
                                    <div class="price_nums">￥{{ individual_detial.price }}</div>
                                </div>
                                <div class="info_form">
                                     <div class="form_flex">
                                        <div class="form_title">服务地区</div>
                                        <div class="form_input1">
                                            <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                                             
                                        </div>
                                     </div>
                                     <div class="form_flex">
                                        <div class="form_title">服务对象</div>
                                        <div class="form_input2">
                                            <div class="tege_list">
                                                <div class="teges teges_ac">企业</div>
                                            </div>
                                        </div>
                                     </div>

                                     <!-- <div class="form_flex">
                                        <div class="form_title">服务项目</div>
                                        <div class="form_input2">
                                            <div class="tege_list">
                                                <div class="teges" :class="{teges_ac:teges_ac==index}" v-for="(item,index) in fwxm_list" :key="index">{{ item.title }}</div>
                                            </div>
                                        </div>
                                     </div> -->
                                </div>
                                <div class="btn_flex">
                                    <div class="btns1" @click="handle_check(individual_detial,1)">在线委托</div>
                                    <div class="btns2" @click="handle_check(individual_detial,2)">预约律师</div>
                                </div>
                            </div>
                        </div>
                        <div class="box1_bom">
                            <div class="box1_bom_bg"></div>
                            <div class="bom_flex">
                                <div class="bom_lefts">
                                    服务承诺
                                </div>
                                <div class="bom_rights">
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon1.png" alt="">
                                        平台监控
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon2.png" alt="">
                                        售后无忧
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon3.png" alt="">
                                        极速退款
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon4.png" alt="">
                                        官方保障
                                    </div>
                                    <!-- <div class="borders"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box2">
                        <div class="box2_tops">
                            <div class="check_type" :class="{check_type_ac:check_ac==index}" v-for="(item,index) in check_list" :key="index" role="button" tabindex="0" :aria-pressed="check_ac==index" @keydown.enter.prevent="handle_ckeck(item,index)" @keydown.space.prevent="handle_ckeck(item,index)" @click="handle_ckeck(item,index)">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="htmls">
                            <div v-html="individual_detial.content" v-if="check_ac==0"></div>
                            <div v-html="individual_detial.content2" v-if="check_ac==1"></div>
                        </div>
                    </div>
                </div>
                <div class="box_right">
                    <legal_detial_new ref="legal_detial_new"></legal_detial_new>
                </div>
             </div>
        </div>
              
        <legal_check ref="legal_check"></legal_check>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import legal_detial_new from '@/components/Legal/legal_detial_new.vue'//右边
 
import legal_check from '@/components/Legal/legal_check.vue'//选择

export default {
    components: {
        legal_detial_new,
        legal_check,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            individual_detial:{},
            banner_ac:0,
            gallery_touch:null,
            banner_img:'',
            banner_list:[
               
            ],
            value:'',
            options:[],
            teges_ac:0,
            fwxm_list:[
                {
                    title:'一审/仲裁',//
                },
                {
                    title:'二审/再审',//
                },
                {
                    title:'执行阶段',//
                }
            ],
            check_ac:0,
            check_list:[
                {
                    title:'服务介绍',
                },
                {
                    title:'服务流程',
                }
            ],
            //地区
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
        }
    },
    computed: {
       
    },
    watch: {
        banner_ac(newobj,oldobj){
            console.log('切换')
            if (this.$refs.banner_list) this.$refs.banner_list.scrollTo({
                left: 90*(this.banner_ac-1),
                behavior: "smooth",
            })
            this.banner_img=this.banner_list[this.banner_ac] || ''
            // this.$refs.banner_list.scrollLeft=
        },
    },
    created() {
        this.get_detial()
        this.get_address()
    },
    methods: {
        gallery_touch_start(event) {
            this.gallery_touch=null
            if(this.mobile_view && event.touches.length===1) this.gallery_touch={x:event.touches[0].clientX,y:event.touches[0].clientY}
        },
        gallery_touch_end(event) {
            const start=this.gallery_touch
            this.gallery_touch=null
            if(!this.mobile_view || !start || !event.changedTouches.length || this.banner_list.length<2) return
            const dx=event.changedTouches[0].clientX-start.x
            const dy=event.changedTouches[0].clientY-start.y
            if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5) this.banner_ac=(this.banner_ac+(dx<0?1:-1)+this.banner_list.length)%this.banner_list.length
        },
        get_address(){
            this.loading = true
            this.$api("getChinaArea", {
                parent_id:1,
                type:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址列表',res)
                if (res.code == 1) {
                    this.area_list=res.data
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleChange(e){
            console.log('e',e)
        },
        get_detial(){
            this.loading = true
            this.$api("serveProInfo", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('商品详情',res)
                if (res.code == 1) {
                   this.individual_detial=res.data
                   this.banner_list=Array.isArray(res.data.images) && res.data.images.length ? res.data.images : (res.data.thumb ? [res.data.thumb] : [])
                   this.banner_ac=0
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //图片
        handle_banner(item,index){
            this.banner_ac=index
        },
        handle_num_clear(){
            if(this.banner_ac==0){

            }else{
                this.banner_ac--
            }
        },
        handle_num_add(){
            if((this.banner_list.length-1)==this.banner_ac){

            }else{
                this.banner_ac++
            }
        },
        handle_ckeck(item,index){
            this.check_ac=index
        },
        //咨询
        handle_check(item,i){
            this.$refs.legal_check.handle_open(item,i,1)
        },
    },

}
</script>
<style scoped lang="less">
.individual_detial{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .individual_detial_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .box_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .box_left{
                .box1{
                    width: 1000px;
                    // min-height: 605px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .box1_top{
                        padding:30px 32px 24px 32px ;
                        display: flex;
                        .box1_banner{
                            width: 340px;
                            flex-shrink: 0;
                            .banner_top{
                                width: 340px;
                                height: 300px;
                            }
                            .banner_bom{
                                margin-top: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .banner_btns{
                                    width: 20px;
                                    height: 56px;
                                    background: #F5F5F5;
                                    border-radius: 4px 0px 0px 4px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    img{
                                        width: 8px;
                                        height: 14px;
                                    }
                                }

                                .banner_list{
                                    width: 280px;
                                    overflow-x: scroll;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 10px;
                                    margin: auto;
                                    .banner_img{
                                        width: 80px;
                                        height: 60px;
                                        margin-right: 10px;
                                        flex-shrink: 0;
                                        cursor: pointer;
                                        border-radius: 4px 4px 4px 4px;
                                        transition: all .5s ease;
                                        img{
                                            width: 80px;
                                            height: 56px;
                                            border-radius: 4px 4px 4px 4px;
                                            border: 2px solid #FFFFFF;

                                        }
                                    }
                                    .banner_img:last-child{
                                        margin-right: 0px;
                                    }
                                    &::-webkit-scrollbar {
                                        display: none;
                                    }
                                    .banner_img_ac{
                                        img{
                                            border: 1px solid #377CFD;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        .box1_info{
                            padding-left: 24px;
                            .info_title_img{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                                img{
                                    width: 19px;
                                    height: 24px;
                                    margin-left: 10px;
                                }
                            }
                            .info_consts{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                padding-top: 24px;
                            }
                            .info_tage{
                                padding-top: 18px;
                                display: flex;
                                align-items: center;
                                .tages{
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00; 
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                    margin-right: 10px;
                                }

                            }
                            .info_price{
                                width: 100%;
                                height: 64px;
                                background-image: url('../../../assets/img/index/legal/bg2.png');
                                background-size: 100%;
                                margin-top: 24px;
                                display: flex;
                                align-items: center;
                                padding: 0 24px;
                                .price_title{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                                .price_nums{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;
                                    padding-left: 16px;
                                }
                               
                            }
                            .info_form{
                                padding-top: 24px;
                                padding-bottom: 32px;
                                border-bottom: 1px solid #EEEEEE;
                                .form_flex{
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 16px;
                                    
                                    .form_title{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                        padding-right: 16px;
                                    }
                                    .form_input1{
                                        width: 260px;
                                        /deep/.el-select{
                                            width: 260px;
                                        }
                                    }
                                    .form_input2{
                                        .tege_list{
                                            display: flex;
                                            align-items: center;
                                            flex-wrap: wrap;
                                            .teges{
                                                padding: 9px 26px;
                                                background: #FFFFFF;
                                                border-radius: 4px 4px 4px 4px;
                                                border: 1px solid #999999;
                                                font-family: Microsoft YaHei, Microsoft YaHei;
                                                font-weight: 400;
                                                font-size: 14px;
                                                color: #999999;
                                                cursor: pointer;
                                                margin-right:10px ;
                                            }
                                            .teges_ac{
                                                border: 1px solid #377CFD;
                                                color: #377CFD;
                                            }
                                        }
                                    }
                                }
                            }
                            .btn_flex{
                                display: flex;
                                align-items: center;
                                padding-top: 24px;
                                .btns1{
                                    width: 134px;
                                    height: 40px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                    line-height: 40px;
                                    cursor: pointer;
                                    margin-right: 10px;
                                }
                                .btns2{
                                    width: 134px;
                                    height: 40px;
                                    background: #FFFFFF;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    line-height: 40px;
                                    text-align: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #377CFD;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .box1_bom{
                        position: relative;
                        width: 100%;
                        height: 60px;
                        .box1_bom_bg{
                            width: 100%;
                            height: 60px;
                            background: linear-gradient( 180deg, #377CFD 0%, #FFFFFF 60%, #FFFFFF 100%);
                            border-radius: 0px 0px 0px 0px;
                            opacity: 0.06;
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                        .bom_flex{
                            width: 100%;
                            height: 60px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 32px;
                            .bom_lefts{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                            }
                            .bom_rights{
                                display: flex;
                                align-items: center;
                                .img_text{
                                    display: flex;
                                    align-items: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #666666;
                                    img{
                                        width: 14px;
                                        // height: 12px;
                                        margin-right: 5px;
                                    }
                                }
                                .borders{
                                    margin: 0 24px;
                                    width: 1px;
                                    height: 14px;
                                    background: #D7D7D7;
                                    border-radius: 0px 0px 0px 0px;
                                }
                            }
                        }
                        
                        
                    }
                }
                .box2{
                    background-color: #FFFFFF;
                    margin-top: 32px;
                    .box2_tops{
                        display: flex;
                        align-items: center;
                        width: 100%;
                        height: 60px;   
                        .check_type{
                            width: 120px;
                            height: 60px;   
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                        }
                        .check_type_ac{
                            border-top: 3px solid #377CFD;
                            color: #377CFD;
                            background: #377CFD;
                            background-color:rgba(55, 124, 253, 0.04) ;
                        }   
                    }
                    .htmls{
                        padding: 20px;
                    }
                }
            }
        }
    }
}

</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .individual_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .individual_detial.no-trans .individual_detial_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .individual_detial.no-trans .individual_detial_box .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .individual_detial.no-trans .individual_detial_box .title_box .span1 {
        margin-right: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .title_box .span2 {
        margin-left: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .title_box img {
        margin-right: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top {
        padding: 16px 16px 16px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom {
        margin-top: 10px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_btns {
        width: 20px;
        height: auto;
        border-radius: 4px 0px 0px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_btns img {
        width: 8px;
        height: 14px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 10px;
        margin: auto;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_list .banner_img {
        width: 80px;
        height: 60px;
        margin-right: 10px;
        border-radius: 4px 4px 4px 4px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_list .banner_img img {
        width: 80px;
        height: 56px;
        border-radius: 4px 4px 4px 4px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_banner .banner_bom .banner_list .banner_img:last-child {
        margin-right: 0px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info {
        padding-left: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_title_img {
        font-size: 24px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_title_img img {
        width: 19px;
        height: 24px;
        margin-left: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_consts {
        font-size: 14px;
        padding-top: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_tage {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_tage .tages {
        padding: 4px 12px;
        border-radius: 3px 3px 3px 3px;
        font-size: 14px;
        margin-right: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_price {
        height: auto;
        margin-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_price .price_title {
        font-size: 14px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_price .price_nums {
        font-size: 24px;
        padding-left: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form {
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex .form_title {
        font-size: 14px;
        padding-right: 16px;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex .form_input1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex .form_input1 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex .form_input2 .tege_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .info_form .form_flex .form_input2 .tege_list .teges {
        padding: 9px 16px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        margin-right: 10px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .btn_flex .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        margin-right: 10px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_top .box1_info .btn_flex .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom {
        height: 60px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .box1_bom_bg {
        height: 60px;
        border-radius: 0px 0px 0px 0px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex {
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex .bom_lefts {
        font-size: 14px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex .bom_rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex .bom_rights .img_text {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex .bom_rights .img_text img {
        width: 14px;
        margin-right: 5px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box1 .box1_bom .bom_flex .bom_rights .borders {
        margin: 0 16px;
        width: 1px;
        height: 14px;
        border-radius: 0px 0px 0px 0px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box2 {
        margin-top: 16px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box2 .box2_tops {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box2 .box2_tops .check_type {
        width: 120px;
        height: auto;
        font-size: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left .box2 .htmls {
        padding: 16px;
    }
}

@media (max-width: 1024px) {
    .individual_detial.no-trans .individual_detial_box .box_flex .box_left { .mobile-service-detail(); }
}

@media (max-width: 1024px) {
    .individual_detial.no-trans .individual_detial_box .box_flex { .mobile-legal-columns(); }
}
@media (max-width: 1024px) {
    .individual_detial.no-trans {
        box-sizing: border-box;
        padding: 0 12px 28px;
        .individual_detial_box {
            .title_box { min-height: 48px; padding: 0; gap: 6px; font-size: 13px; }
            .title_box .breadcrumb_link { display: inline-flex; align-items: center; min-height: 44px; margin: 0; }
            .box_flex .box_left {
                .box1 {
                    .box1_top {
                        padding: 12px 16px 20px;
                        gap: 18px;
                        .box1_banner {
                            .banner_top { position: relative; display: flex; align-items: center; justify-content: center; aspect-ratio: ~"4 / 3"; background: #f3f6fa; border-radius: 4px; }
                            .banner_top img { width: 100%; height: 100%; object-fit: contain; }
                            .gallery_empty { font-size: 40px; color: #a7b8d1; }
                            .gallery_count { position: absolute; right: 10px; bottom: 10px; padding: 2px 8px; background: rgba(30,43,61,.65); border-radius: 4px; color: #fff; font-size: 13px; line-height: 22px; }
                            .banner_bom { margin-top: 0; padding-top: 8px; }
                            .banner_bom .banner_btns { display: flex; align-items: center; justify-content: center; width: 44px; min-width: 44px; height: 44px; }
                        }
                        .box1_info {
                            .info_title_img { display: block; color: #303846; font-size: 21px; font-weight: 600; line-height: 31px; overflow-wrap: anywhere; }
                            .info_title_img img { display: none; }
                            .info_consts { padding-top: 8px; font-size: 14px; line-height: 25px; color: #748091; overflow-wrap: anywhere; }
                            .info_tage { padding-top: 10px; gap: 6px; }
                            .info_tage .tages { margin: 0; padding: 2px 7px; font-size: 13px; line-height: 22px; }
                            .info_price { margin-top: 14px; padding: 12px; background: #f5f8fc; gap: 12px; }
                            .info_price .price_title { font-size: 13px; color: #748091; }
                            .info_price .price_nums { min-width: 0; font-size: 26px; font-weight: 600; line-height: 34px; overflow-wrap: anywhere; }
                            .info_form { padding-top: 16px; }
                            .info_form .form_flex { display: grid; grid-template-columns: 64px minmax(0, 1fr); align-items: center; gap: 8px; min-height: 44px; margin-bottom: 8px; }
                            .info_form .form_flex .form_title { width: auto; padding: 0; font-size: 13px; color: #748091; }
                            .info_form .form_flex .form_input1 { width: 100%; min-width: 0; }
                            .info_form .form_flex .form_input1 /deep/ .el-cascader { width: 100%; line-height: 44px; }
                            .info_form .form_flex .form_input1 /deep/ .el-input__inner { height: 44px; padding-left: 10px; font-size: 16px; border-color: #dfe5ee; }
                            .info_form .form_flex .form_input1 /deep/ .el-input__icon { line-height: 44px; }
                            .info_form .form_flex .form_input2 .tege_list .teges { margin: 0; padding: 4px 12px; font-size: 13px; line-height: 22px; }
                            .btn_flex { gap: 10px; padding-top: 8px; }
                            .btn_flex .btns1, .btn_flex .btns2 { display: flex; align-items: center; justify-content: center; box-sizing: border-box; min-height: 46px; padding: 10px 8px; font-size: 15px; line-height: 24px; border-radius: 4px; }
                        }
                    }
                    .box1_bom {
                        height: auto; margin-top: 0;
                        .bom_flex { display: block; padding: 12px 16px; border: 0; background: #f8faff; }
                        .bom_flex .bom_lefts { margin-bottom: 8px; font-size: 13px; color: #748091; }
                        .bom_flex .bom_rights { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
                        .bom_flex .bom_rights .img_text { flex-wrap: nowrap; gap: 6px; font-size: 13px; line-height: 22px; }
                        .bom_flex .bom_rights .img_text img { margin: 0; flex-shrink: 0; }
                    }
                }
                .box2 {
                    padding: 0 16px; margin-top: 12px; background: #fff;
                    .box2_tops { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0; border-bottom: 1px solid #e5eaf0; background: #fff; }
                    .box2_tops .check_type { box-sizing: border-box; width: 100%; min-width: 0; min-height: 48px; margin: 0; padding: 12px 8px; font-size: 15px; line-height: 24px; background: transparent; color: #748091; border-bottom: 2px solid transparent; }
                    .box2_tops .check_type_ac { color: #2468e8; font-weight: 600; border-bottom-color: #377cfd; }
                    .check_type:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
                    .htmls { padding: 18px 0; font-size: 16px; line-height: 1.9; color: #43526a; overflow-wrap: anywhere; }
                    .htmls /deep/ p { margin: 0 0 14px; }
                    .htmls /deep/ img { display: block; max-width: 100%; height: auto; margin: 12px auto; }
                    .htmls /deep/ h1, .htmls /deep/ h2, .htmls /deep/ h3 { font-size: 18px; line-height: 29px; margin: 20px 0 10px; }
                    .htmls /deep/ table { display: block; max-width: 100%; overflow-x: auto; }
                    .htmls /deep/ ul, .htmls /deep/ ol { padding-left: 22px; }
                    .htmls /deep/ iframe, .htmls /deep/ video { max-width: 100%; }
                    .htmls /deep/ pre { max-width: 100%; overflow-x: auto; white-space: pre-wrap; }
                }
            }
        }
    }
}
</style>
